export default __webpack_public_path__ + "static/media/KGA_Icon.941cd8db.png";